import { mergeErrorCauseWithSentry } from '../common/errors';
import { lWindow } from '../common/helpers';
import { hasRaven } from './browserHelper';

function reportError(error: Error, options = {}) {
  if (typeof lWindow === 'object' && hasRaven(lWindow)) {
    lWindow.Raven.captureException(
      error,
      mergeErrorCauseWithSentry(error, { ...options, level: 'error' })
    );
  }
}

export default reportError;
